import get from 'lodash-es/get';
import React from 'react';

import { useConstants } from '../../../../hooks/useConstants';
import AutocompleteArray from '../../../forms/AutocompleteArray';

type PropertiesProps = {
  name?: string;
  defaultValue?: any[];
};

export default function Properties({ name, defaultValue }: PropertiesProps) {
  const { constants } = useConstants();

  const ACCEPTED_PROPERTIES = get(constants, 'CREATIVE.ACCEPTED_PROPERTIES', {});
  const options = Object.entries(ACCEPTED_PROPERTIES).map(([value, label]) => ({ value, label }));

  return (
    <AutocompleteArray
      label="Properties"
      name={name || 'properties'}
      options={options}
      defaultValue={defaultValue}
      normalizeOutput={(outputArray) => outputArray.map((item) => item.value)}
      normalizeInput={(propertiesIdArray) => options.filter(item => propertiesIdArray?.includes(item.value))}
    />
  );
}
